import React from 'react';
import PropTypes from 'prop-types';

import CollectionCard from '../CollectionCard/CollectionCard';
import { StyledProductBarContainer, StyledProductBar, StyledContainer, StyledWrapper, StyledImageSection, StyledImageContainer, StyledImage, StyledGrid, StyledH5, StyledCaption, StyledMobileCaption, StyledPanoGrid, StyledH3 } from './CustomCollectionStepStyles';

var CustomCollectionStep = function CustomCollectionStep(props) {
  if (props.roomPanoCollectionId) {
    if (props.stepIndex === 0) {
      return React.createElement(
        StyledProductBarContainer,
        null,
        React.createElement(
          StyledH3,
          null,
          props.step.title
        ),
        React.createElement(
          StyledProductBar,
          null,
          props.step.products.map(function (product) {
            return React.createElement(CollectionCard, {
              key: product.node.id + '-' + product.node.default_variant,
              addVariantToCart: props.addVariantToCart,
              product: product.node,
              checkout: props.checkout,
              collectionTitle: props.collectionTitle,
              customCollection: true,
              openProductModal: props.openProductModal,
              isWishlistProduct: props.wishlistProducts.includes(product.node.title),
              toggleAccountModal: props.toggleAccountModal
            });
          })
        )
      );
    }

    // HACKING
    // Adding ',,,left' or ',,,right'
    // to the Customizable Collections image urls
    // will allow for left and right alignment
    var sectionImage = props.customCollectionImages[props.stepIndex - 1];
    var sectionImageAlign = sectionImage && sectionImage.includes(',,,') ? sectionImage.split(',,,')[0] : sectionImage;
    var align = sectionImage && sectionImage.includes(',,,') && sectionImage.split(',,,')[1];

    return React.createElement(
      StyledContainer,
      null,
      React.createElement(
        StyledH3,
        null,
        props.step.title
      ),
      React.createElement(
        StyledWrapper,
        { stepIndex: props.stepIndex },
        props.stepIndex > 0 && React.createElement(
          StyledImageSection,
          { stepIndex: props.stepIndex },
          React.createElement(
            StyledImageContainer,
            { stepIndex: props.stepIndex },
            React.createElement(StyledImage, { src: sectionImageAlign }),
            props.step.description && React.createElement(
              StyledCaption,
              { stepIndex: props.stepIndex, align: align },
              props.step.description
            )
          ),
          props.step.description && React.createElement(
            StyledMobileCaption,
            { stepIndex: props.stepIndex, align: align },
            props.step.description
          )
        ),
        React.createElement(
          StyledPanoGrid,
          null,
          props.step.products.map(function (product) {
            return React.createElement(CollectionCard, {
              key: product.node.id + '-' + product.node.default_variant,
              addVariantToCart: props.addVariantToCart,
              product: product.node,
              checkout: props.checkout,
              collectionTitle: props.collectionTitle,
              customCollection: true,
              openProductModal: props.openProductModal,
              isWishlistProduct: props.wishlistProducts.includes(product.node.title),
              toggleAccountModal: props.toggleAccountModal
            });
          })
        )
      )
    );
  } else {
    return React.createElement(
      'div',
      null,
      React.createElement(
        StyledH5,
        null,
        props.step.title
      ),
      React.createElement(
        StyledGrid,
        null,
        props.step.products.map(function (product) {
          return React.createElement(CollectionCard, {
            key: product.node.id + '-' + product.node.default_variant,
            addVariantToCart: props.addVariantToCart,
            product: product.node,
            checkout: props.checkout,
            collectionTitle: props.collectionTitle,
            customCollection: true,
            openProductModal: props.openProductModal,
            isWishlistProduct: props.wishlistProducts.includes(product.node.title),
            toggleAccountModal: props.toggleAccountModal
          });
        })
      )
    );
  }
};

CustomCollectionStep.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  step: PropTypes.object.isRequired,
  collectionTitle: PropTypes.string.isRequired,
  openProductModal: PropTypes.func.isRequired,
  wishlistProducts: PropTypes.array,
  toggleAccountModal: PropTypes.func.isRequired,
  customCollectionImages: PropTypes.array,
  stepIndex: PropTypes.number
};

export default CustomCollectionStep;